// TANLOV RO'YXATI JORIY QIYMATNI YO'QOTMASIN (N8, 2026-08-15).
//
// =====================================================================
// ⚠️ MUAMMO — antd `Select` MOS `option` TOPMASA XOM `value` NI CHIZADI
// =====================================================================
//
// O'lchangan (Staging, 2026-08-15, `/stock/balances` → ikkinchi
// qatordagi «Count»): «Item» maydonida ekranga
// `cf59ed62-69d5-48cd-bf33-ec269afd48bd` chiqdi. Sabab kodda:
// ro'yxat `.filter((item) => item.active)` bilan TORAYTIRILGAN, qiymat
// esa qoldiq qatoridan kelgan va o'sha mol NOFAOL edi. antd label
// qidiradi, topmaydi va `value` ni o'zini yozadi — jimgina, xatosiz.
//
// Ya'ni bu «xom UUID» oilasining (N4) tuzatish yetib bormagan yarmi:
// `actor-surface.mjs` qorovuli AKTYOR maydonlarini qamraydi, `Select`
// qiymatini emas.
//
// =====================================================================
// ⚠️ QOIDA — bitta jumla
// =====================================================================
//
// Agar `Select` ning qiymati TASHQARIDAN kelsa (`setFieldsValue`,
// `initialValues`, `preset*Id`), ro'yxat esa FILTRLANGAN bo'lsa —
// joriy qiymat ro'yxatga QAYTARIB qo'shilishi kerak.
//
// ⚠️ «Qo'shish» — «tanlash mumkin» degani EMAS. Qaytarilgan yozuv
// `disabled: true` bo'ladi: qoida «TANLAB bo'lmaydi» degan qoida edi,
// va oldindan qo'yilgan qiymat — tanlov EMAS, mavjud holat.
//
// ⚠️ YUBORISHNI to'sish esa ALOHIDA savol va uni SERVER hal qiladi,
// bu yerdagi ro'yxat emas:
//
//   • `stock` — server RAD ETADI (`StockException.ItemInactive`,
//     `StockFlowTest` da mixlangan), ya'ni «Saqlash» ni to'sish
//     aniq 4xx ni oldindan aytish. `StockMovementModal` shuni qiladi;
//   • `hr` — server QABUL QILADI (`requireKnownJobTitle` faqat
//     MAVJUDLIKNI tekshiradi). U yerda to'sish YANGI qoida
//     bo'lardi va zarari aniq: «faqat bo'limni o'zgartiraman» degan
//     operator xodimning lavozimini ham almashtirishga majbur
//     bo'lardi.
//
// ⚠️ NEGA BUTUN NOFAOL RO'YXAT QO'SHILMAYDI. `ExpenseModal` da bu
// savol allaqachon hal qilingan: «ro'yxatda ko'rinib turgan, ammo
// tanlab bo'lmaydigan qator operatorni chalg'itardi». Shuning uchun
// bu yerda FAQAT joriy qiymat qaytariladi — u ekranda BARIBIR
// ko'rinadi, savol faqat NIMA bo'lib ko'rinishida.
//
// ⚠️ `OrgNodeTreeSelect` shu qarorning daraxt shakli: ota-bobolar
// `selectable: false` bilan chiziladi, olib tashlanmaydi.

/** antd `Select` `options` elementining bu yerda ishlatiladigan qismi */
export interface LabeledOption {
  value: string
  label: string
  disabled?: boolean
}

/**
 * Filtrlangan ro'yxatga JORIY qiymatni qaytarib qo'shadi.
 *
 * @param options  toraytirilgan ro'yxat (odatiy holat)
 * @param current  `Select` ning hozirgi qiymati — tashqaridan kelgan
 * @param resolve  ro'yxatdan tushib qolgan qiymat uchun yorliq yasaydi;
 *                 `null` — bunday yozuv umuman yo'q (masalan ma'lumot
 *                 hali yuklanmagan), u holda hech narsa qo'shilmaydi
 *
 * ⚠️ Qaytarilgan ro'yxat — YANGI massiv. Kirish massivi o'zgarmaydi:
 * u odatda `useMemo` natijasi bo'ladi va uni joyida o'zgartirish
 * keyingi render'da ikkinchi nusxani qo'shardi.
 */
export function withCurrentOption(
  options: readonly LabeledOption[],
  current: string | null | undefined,
  resolve: (value: string) => LabeledOption | null,
): LabeledOption[] {
  // Bo'sh qiymat — chizadigan narsa yo'q, `placeholder` ko'rinadi.
  if (current === null || current === undefined || current === '') {
    return [...options]
  }
  if (options.some((option) => option.value === current)) {
    return [...options]
  }
  const missing = resolve(current)
  // ⚠️ BOSHIGA qo'yiladi: qiymat allaqachon tanlangan, ya'ni ro'yxat
  // ochilganda operator uni birinchi ko'rishi kerak.
  return missing === null ? [...options] : [missing, ...options]
}
